import api from './api';

const quoteService = {
    createQuote: async (quoteData) => {
        const response = await api.post('/quotes', quoteData);
        return response.data;
    },

    getQuotesForArtist: async () => {
        const response = await api.get('/quotes/artist');
        return response.data;
    },

    updateQuoteStatus: async (id, status, additionalData = {}) => {
        const response = await api.put(`/quotes/${id}/status`, { status, ...additionalData });
        return response.data;
    },

    addMessage: async (id, content) => {
        const response = await api.post(`/quotes/${id}/messages`, { content });
        return response.data;
    },

    getMessages: async (id) => {
        const response = await api.get(`/quotes/${id}/messages`);
        return response.data;
    },

    getMyQuotes: async () => {
        const response = await api.get('/quotes/my-quotes');
        return response.data;
    },

    markAsViewed: async (id) => {
        const response = await api.put(`/quotes/${id}/mark-viewed`);
        return response.data;
    },

    /**
     * Get all quote updates in a single batch call
     * Returns quotes with last message, unread count, and status
     */
    getQuoteUpdates: async () => {
        const response = await api.get('/quotes/updates');
        return response.data;
    },

    finalizeChat: async (quoteId) => {
        const response = await api.put(`/quotes/${quoteId}/finalize`);
        return response.data;
    }
};

export default quoteService;
